import { getLocalString } from './getLocalString';

// e.g. '4 декабря'
export function getDayAndMonth(dateString) {
    return getLocalString(dateString, { day: 'numeric', month: 'long' });
}
